import { isResourceLoaded } from '~/_shared/types/fetchableResource/fetchableResource.helpers';
import type { ActivePlace } from '~/store/frontendState/activeMapElements/activeMapElements.state';
import { useMapSettingsPlacesSearchesSelector } from '~/store/mapSettings/places/mapSettingsPlaces.selectors';
import { usePlacesSearchResults } from './usePlacesSearchResults';

export const useGetPlaceFromActivePlace = (activePlace?: ActivePlace | null) => {
  const placesSearchResults = usePlacesSearchResults();
  const placeSearches = useMapSettingsPlacesSearchesSelector();

  const activePlaceSearchResults = placesSearchResults.get(activePlace?.placeSearchId ?? '');
  const placeSearch = placeSearches.find(ps => ps.id === activePlace?.placeSearchId);
  const loadedPlaceResultsValue = isResourceLoaded(activePlaceSearchResults) ? activePlaceSearchResults.value : null;
  const placeIndex = loadedPlaceResultsValue?.items.findIndex(p => p.id === activePlace?.id) ?? -1;
  const place = loadedPlaceResultsValue?.items[placeIndex];

  const placeDataLoaded = !!activePlace && !!placeSearch && !!place;

  return {
    place,
    placeSearch,
    placeIndex,
    placeDataLoaded,
  };
};
